<template>
    <career-youth-programs-template-page :show-filter="false" :isLinkCards="false"  hero-title="Молодым<br>специалистам"/>
</template>

<script setup>
import CareerYouthProgramsTemplatePage from './template/CareerYouthProgramsTemplatePage.vue'
</script>

<style lang="scss">
</style>
